import { Syringe } from 'mana-syringe';
export const IFrontendApplicationContribution = Syringe.defineToken('IFrontendApplicationContribution');
//# sourceMappingURL=interface.js.map